import {
  TOPIC_CONTENT_SOURCES,
  type TopicContentSource,
} from "./topic-content-sources";

export const RENTAL_REPAIRS_MOULD_SOURCES_B = [
  {
    sourceId: "rental-repairs-source-condition",
    topicId: "rental-repairs-mould",
    title: "Rental property condition reports",
    publisher: "NSW Fair Trading",
    url: "https://www.nsw.gov.au/housing-and-construction/rules/rental-property-condition-reports",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NSW Government 공식 본문에서 entry·exit condition report, mould section, tenant comments와 timestamped photos의 evidence 역할을 확인",
    reviewStatus: "live_verified",
    claimScope: "repair·mould 문제의 시작상태·변화와 notification evidence",
    followUp: "signed report, tenant amendments, photo metadata와 repair communications를 함께 보관",
  },
  {
    sourceId: "rental-repairs-source-access",
    topicId: "rental-repairs-mould",
    title: "Minimum notice periods for access to rental property",
    publisher: "NSW Fair Trading",
    url: "https://www.nsw.gov.au/housing-and-construction/rules/minimum-notice-periods-for-access-to-rental-property",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NSW Government 공식 본문에서 emergency·urgent repair no-notice access, necessary repair assessment의 current written-notice structure와 tenant privacy를 확인",
    reviewStatus: "live_verified",
    claimScope: "repair inspection·works를 위한 landlord·agent entry notice와 예외",
    followUp: "entry purpose, urgent status, exact notice period와 agreed appointment를 방문 전에 확인",
  },
  {
    sourceId: "rental-repairs-source-rectification",
    topicId: "rental-repairs-mould",
    title: "Rectification orders for rental properties",
    publisher: "NSW Fair Trading",
    url: "https://www.nsw.gov.au/housing-and-construction/rules/rectification-orders-for-rental-properties",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NSW Government 공식 본문에서 written repair request, unresolved Fair Trading complaint, investigation criteria와 rectification order 경로를 확인",
    reviewStatus: "live_verified",
    claimScope: "unresolved NSW rental repair·damage dispute의 Fair Trading rectification process",
    followUp: "complaint reference, written request, repair scope와 current eligibility·evidence requirements 확인",
  },
  {
    sourceId: "rental-repairs-source-ncat",
    topicId: "rental-repairs-mould",
    title: "Tenancy and social housing orders",
    publisher: "NSW Civil and Administrative Tribunal",
    url: "https://ncat.nsw.gov.au/case-types/housing-and-property/tenancy/tenancy-and-social-housing-orders.html",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NCAT 공식 본문에서 section 65 landlord repair order, urgent-repair reimbursement와 receipts·repair details requirements를 확인",
    reviewStatus: "live_verified",
    claimScope: "NCAT repair completion·reimbursement orders와 application evidence",
    followUp: "current section, time limit, fee, interim order와 hearing directions를 신청 전에 확인",
  },
] as const satisfies readonly TopicContentSource[];

const mutableSources = TOPIC_CONTENT_SOURCES as unknown as TopicContentSource[];
for (const source of RENTAL_REPAIRS_MOULD_SOURCES_B) {
  if (!mutableSources.some((existing) => existing.sourceId === source.sourceId)) {
    mutableSources.push(source);
  }
}
